import React, { FC } from 'react'
import EventBusy from '@mui/icons-material/EventBusy'
import NewLayout from './components/NewLayout'

const SiteVisitCanceled: FC = () => {
  return (
    <NewLayout.Outer>
      <NewLayout.Inner size="xl">
        <div className="tw:flex tw:flex-col tw:items-center tw:gap-6">
          <div className="tw:rounded-full tw:p-6 tw:bg-red-100">
            <EventBusy className="tw:!size-12 tw:text-red-600" />
          </div>
          <div className="tw:flex tw:flex-col tw:items-center">
            <p className="tw:text-lg tw:text-center">
              {'This project is no longer available for booking. We’ll notify you as future projects become available'}
            </p>
          </div>
        </div>
      </NewLayout.Inner>
    </NewLayout.Outer>
  )
}

export default SiteVisitCanceled
